import { Component, EventEmitter, Input, Output } from '@angular/core';
import { GeoJsonFeature } from '../../models/geo-json-feature';

type FeatureFull = GeoJsonFeature['properties'];

@Component({
  selector: 'app-feature-inspect',
  standalone: true,
  templateUrl: './feature-inspect.component.html',
  styleUrl: './feature-inspect.component.css',
})
export class FeatureInspectComponent {
  @Input() item!: FeatureFull;
  @Output() closed = new EventEmitter<void>();

  readonly categoryLabels: Record<string, string> = {
    playa: 'Playa',
    arq: 'Arquitectura',
    natural: 'Naturaleza',
    evento: 'Evento',
  };

  getCategoriaLabel(cat: string): string {
    return this.categoryLabels[cat] ?? cat;
  }

  getEntries(): [string, any][] {
    return Object.entries(this.item);
  }
}
